<template>
  <div class="adspace" v-if="$showAds">
    <ins :data-revive-zoneid="zone" :data-revive-term="term" data-revive-id="c53d58e87ecc7d00bbf8919ede59608d"></ins>
    <div :data-revive-term="term"></div>
    <small class="text-right d-block text-muted">Anzeige</small>
  </div>
</template>

<script>
  export default {
    name: 'Ad',
    props: {
      zone: Number,
      term: String
    },
    watch: {
      term () {
        // for some reason this wont update on its own, thus:
        if (this.$el.querySelector && this.$el.querySelector('in')) {
          this.$el.querySelector('in').setAttribute('data-revive-term', this.term);
        }
        // yeah weird way to do it, but using jQuery.data doesnt work either wtf
      }
    }
  };
</script>
